<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
export default {
  components: {ErrorMessage, Layout, PageHeader,ModelSelect },
  data() {
    return {
      title: "Manager Search Ratio",
      items: [
        {
          text: "Manager Search Ratio",
          href: "/",
        },
        {
          text: "Manager",
          active: true,
        },
      ],
      errors: null,
        display_div:true,
      vendors: [],
        ratio:[],
        user_type:"",
      admins: [],
        alladmins:[],
        transaction_types:[],
        transaction_type_id:"",
      pin: "",
      ledgers: [],
      user_id: "",
      crBalance: 0.0,
      drBalance: 0.0,
      totalBalance: 0.0,
        startBalance:0.0,
        endBalance:0.0,
      runningBal: [],
      startdate: "",
      enddate: "",
      remarks: "",
        visible:false,
        message:"",
    };
  },
    // created() {
    //     this.user_id=this.$route.params.user_id;
    // },
  mounted() {
      // if(this.user_id != undefined){
      //     this.getUserID();
      //     this.display_div=false;
      // }
    this.getAdminList();
    // this.transactionTypeList();
    //   this.search();
  },
    // watch: {
    //     $route(to, from) {
    //         this.user_id = this.$route.params.id;
    //     }
    // },
  methods: {
      onClose(){
          this.visible=false;
      },
      toggleDiv: function() {
          this.display_div = !this.display_div;
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/admin/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='admin'){
                                  temp[i].value = temp[i].id;
                                  temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  arr.push(temp[i]);
                              }

                          }
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    async search() {
      try {
        axios
          .get("/api/search-book-ratio-manager", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              user_id: this.user_id,
              startdate: this.startdate,
              enddate: this.enddate,
            },
          })
          .then((response) => {
            if (response.data.status) {
                this.ratio=response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async clear() {
              this.startdate="";
              this.enddate="";
              this.user_id="";
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.$swal("Error", obj.message, "error");
        this.search();
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
            <div v-if="display_div" class="row">
<!--                <div class="col-md-4">-->
<!--                    <div class="form-group">-->
<!--                        <label for="user_type">Select User Type</label>-->
<!--                        <select-->
<!--                            id="user_type"-->
<!--                            name="user_type"-->
<!--                            v-model="user_type"-->
<!--                            @change="onChange($event)"-->
<!--                            class="form-control"-->
<!--                            placeholder="Select User Type">-->
<!--                            <option value="b2b">B2B-->
<!--                            </option>-->
<!--                            <option value="b2c">B2C-->
<!--                            </option>-->
<!--                        </select>-->
<!--                    </div>-->
<!--                </div>-->
              <div class="col-md-4">
                <div class="form-group">
                  <label>Select Manager</label>
                    <model-select :options="admins"
                                  v-model="user_id"
                                  placeholder="Select User">
                    </model-select>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label for="start-datepicker-1">Start Date</label>
                  <b-form-datepicker id="start-datepicker" v-model="startdate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label for="end-datepicker">End Date</label>
                  <b-form-datepicker id="end-datepicker" v-model="enddate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
<!--                <div class="col-md-4">-->
<!--                    <div class="form-group">-->
<!--                        <label for="type_id">Transaction Type</label>-->
<!--                        <select-->
<!--                            id="type_id"-->
<!--                            name="type_id"-->
<!--                            v-model="transaction_type_id"-->
<!--                            class="form-control"-->
<!--                            placeholder="Type Select User">-->
<!--                            <option v-for="(transaction_type, index) in transaction_types" :value="transaction_type.id"-->
<!--                                    v-bind:key="index">{{ transaction_type.type_name }}-->
<!--                            </option>-->
<!--                        </select>-->
<!--                    </div>-->
<!--                </div>-->
              <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <div class="table-responsive table-responsive-sm">
                  <table class="table mb-0 table-striped">
                      <thead>
                      <tr>
                          <th>SL</th>
                          <th>User Name</th>
                          <th>Search Count</th>
                          <th>Book Count</th>
                          <th>Ticket Count</th>
                          <th>Cancel Count</th>
                          <th>Search Book Ratio</th>
                          <th>Search Ticket Ratio</th>
                          <th>Cancel Ratio</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(managerUser,index) in ratio" v-bind:key="index" v-if="managerUser.search_count>0">
                          <th scope="row">{{index+1}}</th>
                          <td>{{managerUser.user_name}}</td>
                          <td>{{managerUser.search_count}}</td>
                          <td>{{managerUser.booking_count}}</td>
                          <td>{{managerUser.ticketing_count}}</td>
                          <td>{{managerUser.cancel_count}}</td>
                          <td>{{managerUser.search_book_ratio}}</td>
                          <td>{{managerUser.search_ticket_ratio}}</td>
                          <td>{{managerUser.book_cancel_ratio}}</td>


<!--                          <td><router-link :to="{ name: 'role_update', params: {id: role.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(role)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>-->
                      </tr>
                      </tbody>
                  </table>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.dropdown-menu.show {
    display: block;
    z-index: 10003;
}
#start-datepicker__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
.margin-30per{
    margin-right: 30%;
}
</style>
